import {
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const inputStyles = {
  width: '100%',

  'input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },
  'input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },

  '&:hover': {
    '&:has(.MuiInputBase-root.Mui-error)': {
      '.MuiFormLabel-root': {
        color: `${primaryColors.orange} !important`
      }
    },
    '&:has(.MuiInputBase-root.Mui-error > .MuiInputBase-input:focus)': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${primaryColors.orange} !important`
      },
      '.MuiFormLabel-root': {
        color: `${primaryColors.orange} !important`
      }
    },
    '.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.Mui-error.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.white} !important`
    },
    '.MuiFormLabel-root': {
      '&[data-shrink="true"]': {
        color: `${primaryColors.white} !important`,
        textTransform: 'uppercase'
      },
      '&:hover': {
        color: 'inherit'
      }
    }
  },

  '&:has(.MuiInputBase-root.Mui-error > .MuiInputBase-input:focus)': {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.MuiFormLabel-root': {
      '&:hover': {
        color: `${primaryColors.orange} !important`
      },
      '&[data-shrink="true"]': {
        color: `${primaryColors.orange} !important`
      }
    }
  },

  '&:has(.MuiInputBase-root > .MuiInputBase-input:focus)': {
    '.MuiFormLabel-root': {
      '&[data-shrink="true"]': {
        color: `${primaryColors.white} !important`
      }
    }
  },

  '.MuiInputBase-root::first-letter': {
    textTransform: 'capitalize'
  },

  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${whiteShades.shade1} !important`
  },
  '.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.Mui-error.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.MuiInputBase-root input': {
    textTransform: 'none'
  },

  '.MuiInputBase-root:has(textarea)': {
    padding: '0.5rem'
  },

  '.MuiFormLabel-root': {
    color: `${whiteShades.shade1} !important`,
    fontFamily: 'Helvetica Neue, sans-serif',
    fontWeight: 900,
    fontStretch: 'condensed',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    transform: 'translate(14px, 7px)',
    '&[data-shrink="true"]': {
      transform: 'translate(14px, -9px)'
    },
    '&.Mui-disabled': {
      textTransform: 'uppercase !important'
    }
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${whiteShades.shade1} !important`,
    top: '-4px',
    '&:hover': {
      borderColor: `${primaryColors.white}`
    },
    'legend span': {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 900,
      fontStretch: 'condensed',
      textTransform: 'uppercase',
      fontSize: '0.875rem',

      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',

      '&[aria-hidden="true"]': {
        paddingLeft: '0',
        paddingRight: '0'
      }
    }
  },

  '.Mui-disabled': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${whiteShades.shade1}`
    },
    '&.MuiFormLabel-root': {
      color: `${whiteShades.shade1} !important`,
      textTransform: 'uppercase'
    }
  },

  '.Mui-focused.Mui-error': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${primaryColors.orange}`
    },
    '&.MuiFormLabel-root': {
      color: `${primaryColors.orange} !important`,
      textTransform: 'uppercase',
      '&:hover': {
        color: `${primaryColors.orange} !important`
      }
    }
  },

  '.MuiAutocomplete-root.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline':
    {
      borderColor: primaryColors.orange
    },

  '.MuiInputBase-root .Mui-error:hover .MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${primaryColors.orange}`
  },

  '.MuiFormHelperText-root': {
    fontFamily: 'Helvetica Neue, sans-serif',
    fontWeight: 900,
    fontStretch: 'condensed',
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    margin: 0,

    '&.Mui-error': {
      color: primaryColors.orange
    }
  },

  '.MuiInputBase-root.Mui-disabled': {
    color: `${primaryColors.white} !important`,
    WebkitTextFillColor: primaryColors.white,
    textTransform: 'none',

    borderRadius: '0.25rem',
    '.MuiOutlinedInput-notchedOutline': {
      backgroundColor: transparentColors.transparent,
      textTransform: 'none'
    }
  },

  '.MuiOutlinedInput-root': {
    color: primaryColors.white,
    '&:has(.MuiInputBase-input:focus)': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${primaryColors.white} !important`
      }
    }
  },

  '.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.white}`
  },

  '&.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      borderColor: `${primaryColors.white}`
    },

  '.MuiInputBase-input': {
    fontSize: '1rem',
    fontFamily: 'Helvetica Neue, sans-serif',
    fontWeight: 400,
    fontStretch: 'condensed',

    padding: '0.5rem 0.75rem',
    '&::-webkit-scrollbar': {
      width: '0.5rem'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: transparentColors.orangeShade4,
      borderRadius: '0.5rem',
      cursor: 'pointer'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: transparentColors.transparent,
      borderRadius: '0.5rem'
    },
    '&::placeholder': {
      color: whiteShades.shade1,
      opacity: 1,
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 400,
      fontStretch: 'condensed'
    }
  },

  '.MuiInputBase-input.MuiInputBase-inputMultiline': {
    padding: '0 0.25rem',
    textTransform: 'capitalize'
  },

  '.MuiOutlinedInput-input': {
    height: '2.125rem',
    '&.Mui-disabled': {
      color: `${primaryColors.white} !important`,
      WebkitTextFillColor: primaryColors.white
    }
  }
}

export const inputAdornmentStyles = {}
